/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Internalreportingexclude2Inputs */

const en_entity_internalreportingexclude2 = /** @type {(inputs: Entity_Internalreportingexclude2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal Reporting Exclude`)
};

const de_entity_internalreportingexclude2 = /** @type {(inputs: Entity_Internalreportingexclude2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von interner Berichterstattung ausgeschlossen`)
};

/**
* | output |
* | --- |
* | "Internal Reporting Exclude" |
*
* @param {Entity_Internalreportingexclude2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_internalreportingexclude2 = /** @type {((inputs?: Entity_Internalreportingexclude2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Internalreportingexclude2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_internalreportingexclude2(inputs)
	return de_entity_internalreportingexclude2(inputs)
});
export { entity_internalreportingexclude2 as "entity_internalReportingExclude" }